import React from 'react';
import { styled } from 'linaria/react';
import { use100vh } from 'react-div-100vh';
import { SnackbarProvider } from 'fronton-react';
import { DataContext, TData } from 'entries/common/widgets/door-project/context';
import { Content } from './components/Content/content';
import { DRAWER_HEADER_HEIGHT } from './const';

export const DoorProjectForm = ({ data }: { data: TData }) => {
  const height = use100vh();
  const calculatedHeight = height
    ? height - DRAWER_HEADER_HEIGHT
    : `calc(100vh - ${DRAWER_HEADER_HEIGHT}px)`;

  return (
    <DataContext.Provider value={data}>
      <SnackbarProvider>
        <Layout height={calculatedHeight}>
          <Container>
            <Content />
          </Container>
        </Layout>
      </SnackbarProvider>
    </DataContext.Provider>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

const Layout = styled.div<{ height: number | string }>`
  width: 100%;
  height: ${props => props.height}px;
`;
